import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Transition } from 'react-transition-group';
import { TweenMax } from 'gsap';

import Answer from './Answer';

import { answerSelect, updateView, updateQuestion, tallyResults } from '../../../actions';
import { track } from '../../../utils/analytics';
import { processLines } from '../../../utils/string';

import style from './index.module.scss';

class Question extends Component {
  constructor(props) {
    super(props);

    this.state = {
      direction: 'forward',
      active: false
    }

    this.handleAnswerClick = this.handleAnswerClick.bind(this);
    this.animateOut = this.animateOut.bind(this);
    this.animateIn = this.animateIn.bind(this);
  }

  animateIn() {
    const title = this.container.querySelector(`.${style.type}`);
    const answers = this.container.querySelectorAll('[data-role="answer"]');
    const pagination = document.querySelector('[data-role="pagination"]');
    TweenMax.staggerTo([title, ...answers, pagination], 1, { autoAlpha: 1, delay: 1 }, 0.1);
    // console.log('animate in', this.props);
    // this.props.onHandleAnimateIn.call(this);
  }

  animateOut() {
    const { dispatch, quiz: { pool, current } } = this.props;
    const title = this.container.querySelector(`.${style.type}`);
    const answers = this.container.querySelectorAll('[data-role="answer"]');
    const pagination = document.querySelector('[data-role="pagination"]');
    TweenMax.staggerTo([pagination, title, ...answers], 0.5, { opacity: 0 }, 0.1, () => {
      if (current === pool.length - 1) {
        dispatch(tallyResults());
        dispatch(updateView('results'));
      } else dispatch(updateQuestion({ current: current + 1, prev: current }));
    });
  }

  handleAnswerClick(index, text) {
    const { dispatch } = this.props;

    dispatch(answerSelect(index));
    this.animateOut();
    
    track('answered', `${text} ${index}`);
  }

  componentDidMount() {
    const title = this.container.querySelector(`.${style.type}`);
    const answers = this.container.querySelectorAll('[data-role="answer"]');
    TweenMax.set([title, this.underline, ...answers], { autoAlpha: 0 });
  }

  render() {
    const { show, base: { app }, question: { question, answers, index }, themes, layout: { mobile } } = this.props;
    const { videoHidden } = this.state;
    const theme = themes[index];

    return (
      <Transition
        timeout={0}
        in={show}
        onEnter={() => {
          track('visible', `quiz question ${question}`);
          this.setState(() => ({ active: true }))
        }}
        onExit={() => this.setState(() => ({ active: false }))}
        addEndListener={(node, done) => {
          if (show) this.animateIn();
        }}
      >
        <div className={`${style.question} ${show ? style.active : ''}`} style={{ color: app.primaryColor }} ref={instance => this.container = instance}>
          <div className={style.wrapper}>
            <div className={style['title-content']} data-theme-index={index}>
              <div className={style.type}>
                {processLines(question).map((line, index) => <div key={`line-${index}`}>{line}</div>)}
              </div>
              <div className={style.underline} style={{ borderBottom: mobile ? `1px solid ${theme.secondaryColor}` : null }} ref={instance => this.underline = instance} />
            </div>
            <div className={`${style.copy} ${!videoHidden && mobile ? style.hide : ''}`} ref={instance => this.copy = instance}>
              <div className={style.answers}>
                {answers.map((answer, idx) => <Answer {...answer} show={show} primaryColor={app.primaryColor} secondaryColor={app.secondaryColor} theme={theme} idx={idx} delay={idx * 0.3} onClick={this.handleAnswerClick} key={`answer-top-${idx}`} />)}
              </div>
            </div>
          </div>
        </div>
      </Transition>
    )
  }
}

const mapStateToProps = state => ({
  view: state.view,
  quiz: state.quiz,
  cover: state.cover,
  themes: state.themes,
  layout: state.layout,
  base: state.base
});

export default connect(mapStateToProps)(Question);
